export const nutrientTranslations: Record<string, string> = {
  'Protein': 'Fehérje',
  'Total lipid (fat)': 'Összes zsír',
  'Carbohydrate, by difference': 'Szénhidrát',
  'Energy': 'Energia',
  'Water': 'Víz',
  'Fiber, total dietary': 'Rost',
  'Sugars, total including NLEA': 'Összes cukor',
  'Vitamin D (D2 + D3), International Units': 'D-vitamin (D2 + D3), NE',
  'Vitamin C, total ascorbic acid': 'C-vitamin',
  'Folate, total': 'Folát',
  'Vitamin B-12': 'B12-vitamin',
  'Choline, total': 'Kolin',
  'Calcium, Ca': 'Kalcium, Ca',
  'Iron, Fe': 'Vas, Fe',
  'Magnesium, Mg': 'Magnézium, Mg',
  'Potassium, K': 'Kálium, K',
  'Sodium, Na': 'Nátrium, Na',
  'Fatty acids, total trans': 'Transz-zsírsavak',
  'Fatty acids, total saturated': 'Telített zsírsavak',
  'PUFA 22:6 n-3 (DHA)': 'DHA (omega-3)',
  'PUFA 20:5 n-3 (EPA)': 'EPA (omega-3)',
  'PUFA 18:3 n-3 c,c,c (ALA)': 'ALA (omega-3)',
  'Vitamin A, RAE': 'A-vitamin, RAE',
  'Vitamin E (alpha-tocopherol)': 'E-vitamin',
  'Vitamin B-6': 'B6-vitamin',
  'Vitamin K (phylloquinone)': 'K-vitamin',
  'Folate, DFE': 'Folát, DFE',
  'Phosphorus, P': 'Foszfor, P',
  'Zinc, Zn': 'Cink, Zn',
  'Copper, Cu': 'Réz, Cu',
  'Fluoride, F': 'Fluor, F',
  'Manganese, Mn': 'Mangán, Mn',
  'Selenium, Se': 'Szelén, Se',
  'Vitamin A, IU': 'A-vitamin, NE',
  'Retinol': 'Retinol',
  'Carotene, beta': 'Béta-karotin',
  'Carotene, alpha': 'Alfa-karotin',
  'Vitamin D2 (ergocalciferol)': 'D2-vitamin (ergokalciferol)',
  'Vitamin D3 (cholecalciferol)': 'D3-vitamin (kolekalciferol)',
  'Vitamin D (D2 + D3)': 'D-vitamin (D2 + D3)',
  'Tocopherol, beta': 'Béta-tokoferol',
  'Tocopherol, gamma': 'Gamma-tokoferol',
  'Tocopherol, delta': 'Delta-tokoferol',
  'Tocotrienol, alpha': 'Alfa-tokotrienol',
  'Tocotrienol, beta': 'Béta-tokotrienol',
  'Tocotrienol, gamma': 'Gamma-tokotrienol',
  'Tocotrienol, delta': 'Delta-tokotrienol',
  'Thiamin': 'Tiamin (B1)',
  'Riboflavin': 'Riboflavin (B2)',
  'Niacin': 'Niacin (B3)',
  'Pantothenic acid': 'Pantoténsav (B5)',
  'Vitamin K (Menaquinone-4)': 'K-vitamin (Menakinon-4)',
  'Vitamin K (Dihydrophylloquinone)': 'K-vitamin (Dihidrofillokinon)',
  'Folate, food': 'Természetes folát',
  'Starch': 'Keményítő',
  'Sucrose': 'Szacharóz',
  'Glucose': 'Glükóz',
  'Fructose': 'Fruktóz',
  'Lactose': 'Laktóz',
  'Maltose': 'Maltóz',
  'Galactose': 'Galaktóz',
  'Tryptophan': 'Triptofán',
  'Threonine': 'Treonin',
  'Isoleucine': 'Izoleucin',
  'Leucine': 'Leucin',
  'Lysine': 'Lizin',
  'Methionine': 'Metionin',
  'Cystine': 'Cisztin',
  'Phenylalanine': 'Fenilalanin',
  'Tyrosine': 'Tirozin',
  'Valine': 'Valin',
  'Arginine': 'Arginin',
  'Histidine': 'Hisztidin',
  'Alanine': 'Alanin',
  'Aspartic acid': 'Aszparaginsav',
  'Glutamic acid': 'Glutaminsav',
  'Glycine': 'Glicin',
  'Proline': 'Prolin',
  'Serine': 'Szerin',
  'Hydroxyproline': 'Hidroxiprolin',
  'SFA 4:0': 'SFA 4:0',
  'SFA 6:0': 'SFA 6:0',
  'SFA 8:0': 'SFA 8:0',
  'SFA 10:0': 'SFA 10:0',
  'SFA 12:0': 'SFA 12:0',
  'SFA 14:0': 'SFA 14:0',
  'SFA 16:0': 'SFA 16:0',
  'SFA 18:0': 'SFA 18:0',
  'SFA 20:0': 'SFA 20:0',
  'MUFA 18:1': 'MUFA 18:1',
  'PUFA 18:2': 'PUFA 18:2',
  'PUFA 18:3': 'PUFA 18:3',
  'PUFA 20:4': 'PUFA 20:4',
  'SFA 22:0': 'SFA 22:0',
  'MUFA 14:1': 'MUFA 14:1',
  'MUFA 16:1': 'MUFA 16:1',
  'PUFA 18:4': 'PUFA 18:4',
  'MUFA 20:1': 'MUFA 20:1',
  'MUFA 22:1': 'MUFA 22:1',
  'PUFA 22:5 n-3 (DPA)': 'DPA (omega-3)',
  'Fatty acids, total monounsaturated': 'Egyszeresen telítetlen zsírsavak',
  'Fatty acids, total polyunsaturated': 'Többszörösen telítetlen zsírsavak',
  'SFA 15:0': 'SFA 15:0',
  'SFA 17:0': 'SFA 17:0',
  'SFA 24:0': 'SFA 24:0',
  'TFA 16:1 t': 'TFA 16:1 t',
  'TFA 18:1 t': 'TFA 18:1 t',
  'TFA 22:1 t': 'TFA 22:1 t',
  'TFA 18:2 t not further defined': 'TFA 18:2 t (nem részletezett)',
  'PUFA 18:2 i': 'PUFA 18:2 i',
  'TFA 18:2 t,t': 'TFA 18:2 t,t',
  'PUFA 18:2 CLAs': 'PUFA 18:2 CLAs',
  'MUFA 24:1 c': 'MUFA 24:1 c',
  'PUFA 20:2 n-6 c,c': 'PUFA 20:2 n-6 c,c',
  'MUFA 16:1 c': 'MUFA 16:1 c',
  'MUFA 18:1 c': 'MUFA 18:1 c',
  'PUFA 18:2 n-6 c,c': 'PUFA 18:2 n-6 c,c',
  'MUFA 22:1 c': 'MUFA 22:1 c',
  'PUFA 18:3 n-6 c,c,c': 'PUFA 18:3 n-6 c,c,c',
  'MUFA 17:1': 'MUFA 17:1',
  'PUFA 20:3': 'PUFA 20:3',
  'Fatty acids, total trans-monoenoic': 'Transz-monoénsavak',
  'Fatty acids, total trans-polyenoic': 'Transz-poliénsavak',
  'SFA 13:0': 'SFA 13:0',
  'MUFA 15:1': 'MUFA 15:1',
  'PUFA 20:3 n-3': 'PUFA 20:3 n-3',
  'PUFA 20:4 n-6': 'PUFA 20:4 n-6',
  'PUFA 18:3i': 'PUFA 18:3i',
  'PUFA 22:4': 'PUFA 22:4',
  'MUFA 18:1-11 t (18:1t n-7)': 'MUFA 18:1-11 t (18:1t n-7)',
  'Cholesterol': 'Koleszterin',
  'Phytosterols': 'Fitoszterolok',
  'Stigmasterol': 'Sztigmaszterol',
  'Campesterol': 'Kampeszterol',
  'Beta-sitosterol': 'Béta-szitoszterol',
  'Theobromine': 'Teobromin',
  'Cryptoxanthin, beta': 'Béta-kriptoxantin',
  'Lycopene': 'Likopin',
  'Lutein + zeaxanthin': 'Lutein + zeaxantin',
  'Betaine': 'Betain'
}

import type { Lang } from './translations'

export const foodStateTranslations: Record<Lang, Record<string, string>> = {
  hu: { raw: 'nyers', cooked: 'főtt', baked: 'sült' },
  en: { raw: 'raw', cooked: 'cooked', baked: 'baked' },
}

export function translateNutrient(name: string, lang: Lang = 'hu'): string {
  if (lang === 'en') return name
  return nutrientTranslations[name] || name
}

export function translateFoodState(state: string, lang: Lang = 'hu'): string {
  return foodStateTranslations[lang][state.toLowerCase()] ?? state
}

const nutrientCategoryTranslations: Record<Lang, Record<string, string>> = {
  hu: {
    basics: 'Alapok',
    sugars: 'Cukrok',
    vitamins: 'Vitaminok',
    minerals: 'Ásványi anyagok',
    aminoacids: 'Aminosavak',
    fattyacids: 'Zsírsavak',
    sterols: 'Szterolok',
    magic: 'Egyéb',
  },
  en: {
    basics: 'Basics',
    sugars: 'Sugars',
    vitamins: 'Vitamins',
    minerals: 'Minerals',
    aminoacids: 'Amino Acids',
    fattyacids: 'Fatty Acids',
    sterols: 'Sterols',
    magic: 'Other',
  },
}

export function translateNutrientCategory(category: string, lang: Lang = 'hu'): string {
  return nutrientCategoryTranslations[lang][category] ?? category
}

export function foodStateBadgeClass(state: string): string {
  return state === 'raw' ? 'bg-warning text-dark' : 'bg-success'
}